/*
  <collection-filters-toggle> wraps the Filters button in the collection toolbar.

  The sidebar is shown or hidden by the `facets-vertical--collapsed` class on the
  `.facets-vertical` layout wrapper (see component-facets-toggle.css). facets.js replaces
  the whole product grid container, toolbar included, after every filter change,
  so this element re-reads its state from the wrapper each time it connects
  instead of keeping any of its own.

  The visitor's choice is remembered for the session in sessionStorage; the
  section's inline script applies it before first paint. Pages loaded with
  active filters always start open (server-side).
*/
class CollectionFiltersToggle extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('button');
    this.layout = this.closest('.facets-vertical');
    if (!this.button || !this.layout) return;
    this.button.addEventListener('click', this.toggle);
    this.sync();
  }

  disconnectedCallback() {
    if (this.button) this.button.removeEventListener('click', this.toggle);
  }

  get isOpen() {
    return !this.layout.classList.contains('facets-vertical--collapsed');
  }

  sync() {
    this.button.setAttribute('aria-expanded', String(this.isOpen));
  }

  toggle() {
    this.layout.classList.toggle('facets-vertical--collapsed', this.isOpen);
    this.sync();
    try {
      sessionStorage.setItem('pbs-filters-open', this.isOpen ? '1' : '0');
    } catch (e) {
      /* storage unavailable, nothing to remember */
    }
    if (this.isOpen) {
      const firstSummary = this.layout.querySelector('#main-collection-filters summary');
      if (firstSummary) firstSummary.focus({ preventScroll: true });
    }
  }
}

if (!customElements.get('collection-filters-toggle')) {
  customElements.define('collection-filters-toggle', CollectionFiltersToggle);
}
